import { createRouter, createWebHistory } from 'vue-router';

import Home from '@delivery/views/Home.vue';

const router = createRouter({
  history: createWebHistory((import.meta as any).env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    }
  ]
});

export default router;
